/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_WeighingInputs */

const vi_tea_lot_weighing = /** @type {(inputs: Tea_Lot_WeighingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu cân`)
};

/**

* @param {Tea_Lot_WeighingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_weighing = /** @type {((inputs?: Tea_Lot_WeighingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_WeighingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_weighing(inputs)
});